module.exports = __webpack_public_path__ + "static/media/LogoClearInverted.e8abb07f.png";